let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("10HP2")).then(() => parcelRequire('cURTI'));